module.exports = __webpack_public_path__ + "img/5_of_Clubs.svg.737ea7c5.png";